<template>
  <v-card-text class="pa-0" style="height:600px; margin-top: 16px !important;margin-bottom: 16px !important;overflow-y: overlay;">    
    <v-container grid-list-xl v-if="registeredItems.length !== 0">      
      <v-layout row wrap class="titulo-detalhes-categoria">              
        <v-flex xs12 sm12 md2>
          Categorias
        </v-flex>
        <v-flex xs12 sm12 md10>
          <v-select
            :items="categories"
            :rules="rules.categories"
            @input="setSelectedScheduleCategory"
            v-model="categorySelected"            
            item-text="name"
            item-value="id"     
            label=""        
            single-line
            bottom
            required>
          </v-select>
        </v-flex>
      </v-layout>      
      <v-layout row>
        <v-flex xs12 sm12>
          <v-card>
            <v-toolbar color="elevation-0" extended>              
              <v-toolbar-title>Selecione o(s) item(ns) desejado(s)</v-toolbar-title>              
              <v-text-field
                v-model="searchItem" 
                prepend-icon="search" 
                hide-details 
                single-line
                placeholder="Pesquisar itens"
                slot="extension"
                >
              </v-text-field>
              <v-tooltip bottom slot="extension">
                <v-btn slot="activator" :disabled="registeredItems.length === 0" icon @click.prevent="selectAll">
                  <v-icon color="green darken-2">check_circle</v-icon>
                </v-btn>  
                <span>Selecionar todos</span>
              </v-tooltip>              
            </v-toolbar>
            <v-list three-line style="padding: 0px;">
              <template v-for="item of filteredItens" >
                <item-box :value="item" :key="item.id"></item-box>
              </template>              
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else>
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center pt-5 no-item-text">
          <h4>
            Não existe nenhum item cadastrado.<br>
            <span @click="newItem">Cadastre um aqui</span>
          </h4>
        </v-flex>
      </v-layout>
    </v-container>    
  </v-card-text>
</template>


<script>
import itemBox from '../../sharedComponents/item/list-box'
export default {
  name: 'select-item',
  components: {
    'item-box': itemBox
  },
  data () {
    return {
      searchItem: '',
      rules: {
        categories: [
          (v) => !!v > 0 || 'Selecione uma categoria'
        ]
      }
    }
  },
  methods: {
    newItem () {
      this.$router.push('/Painel/Itens/Relacao/')
    },
    selectAll () {
      for (let index = 0; index < this.$store.getters.registeredItemsActive.length; index++) {
        this.$store.commit('addItemForScheduled', this.$store.getters.registeredItemsActive[index])
      }
    },
    setSelectedScheduleCategory (value) {
      this.$store.commit('setSelectedScheduleCategory', value)
    }
  },
  mounted () {
    this.$store.dispatch('getItems')
    this.$store.dispatch('loadAllowedCategories')
  },
  computed: {
    categorySelected: {
      get () {
        return this.$store.getters.selectedScheduleCategory
      },
      set (value) {
        this.$store.commit('setSelectedScheduleCategory', value)
      }
    },
    registeredItems () {
      return this.$store.getters.registeredItemsActive
    },
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    categories () {
      return this.$store.getters.allowedCategoriesForScheduled
    },
    filteredItens () {
      if (this.categorySelected === '') {
        return []
      } else if (this.searchItem === '') {
        return this.registeredItems.filter(elem => {
          if (elem.categories === this.categorySelected) {
            return elem
          }
        })
      } else {
        return this.registeredItems.filter((elem) => {
          if (elem.categories === this.categorySelected) {
            let exp = new RegExp(this.searchItem.trim(), 'i')
            let searchItem = elem.description +
              elem.name +
              elem.tags.join()
            if (elem.priceVariations) {
              searchItem = searchItem + elem.priceTable.map(elemRow => String(elemRow.price).replace('.', ',') + ' ' + String(elemRow.priceRef).replace('.', ',') + ' ' + elemRow.description).join()
            } else {
              searchItem = searchItem + String(elem.price).replace('.', ',')
            }
            return exp.test(searchItem)
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.has-item{
  background: rgba(0, 0, 0, 0.32);
}
.no-item-text{
  color:#b1b1b1;
  font-size: 18px;
}
.no-item-text span{
  color: #e24054;
  font-weight: bold;
  cursor: pointer;
}
.select-tip {
  font-weight: 500;
  color: #b1b1b1;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// selectItem.vue?4def4888